import { render, staticRenderFns } from "./closeV2Icon.vue?vue&type=template&id=bccde272&scoped=true&"
import script from "./closeV2Icon.vue?vue&type=script&lang=js&"
export * from "./closeV2Icon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bccde272",
  null
  ,true
)

export default component.exports